import { Routes } from "src/routes";
import { typeCheckAppModule } from "src/utils";
import { NAME } from "./constants";
import { GoogleCallbackPage } from "./GoogleCallbackPage";

export { GoogleButton } from "./GoogleButton";

export const googleCallback = typeCheckAppModule({
    NAME,
    Container: GoogleCallbackPage,
    route: Routes.googleCallback,
    secure: false,
});
